import { render, staticRenderFns } from "./systemExceptionLog.vue?vue&type=template&id=4d794a7f&scoped=true&"
import script from "./systemExceptionLog.vue?vue&type=script&lang=js&"
export * from "./systemExceptionLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d794a7f",
  null
  
)

component.options.__file = "systemExceptionLog.vue"
export default component.exports